const loginHelpResetPwdVerificationCodeTemplate = `
    <pwr-reset-password-mfa-verify-code>
    </pwr-reset-password-mfa-verify-code>`;
export default loginHelpResetPwdVerificationCodeTemplate;
